import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-cree-bon-sortie',
  templateUrl: './cree-bon-sortie.component.html',
  styleUrls: ['./cree-bon-sortie.component.scss']
})
export class CreeBonSortieComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
